<div class="container-sm my-3">
    <div class="text-secondary fst-italic">{{ "survey.new.ndg-data.text-1" | translate }}</div>
    <div class="text-secondary fst-italic">{{ "survey.new.ndg-data.text-2" | translate }}</div>

    <div [formGroup]="ndgForm">
        <!-- TYPOLOGY -->
        <div class="form-group row my-3">
            <label for="type" class="col-4 col-form-label">{{ "survey.new.ndg-data.type" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="type" formControlName="type">
                    <option *ngFor="let key of ['FIS', 'GIU']" [value]="key">
                        {{ "survey.domain.ndg.type." + key | translate }}
                    </option>
                </select>
            </div>
        </div>

        <!-- FULL NAME -->
        <div class="form-group row my-3">
            <label for="name" class="col-4 col-form-label">{{ "survey.new.ndg-data.name" | translate }}</label>
            <div class="col-8">
                <input class="form-control" id="name" [value]="ndg.fullName" disabled="true">
            </div>
        </div>

        <!-- FISCAL CODE -->
        <div class="form-group row my-3">
            <label for="fiscalCode" class="col-4 col-form-label">{{ "survey.new.ndg-data.fiscal-code" | translate }}</label>
            <div class="col-8">
                <input class="form-control" id="fiscalCode" [value]="ndg.fiscalCode" disabled="true">
            </div>
        </div>

        <!-- FULL ADDRESS -->
        <div class="form-group row my-3">
            <label for="fullAddress" class="col-4 col-form-label">{{ "survey.new.ndg-data.address" | translate }}</label>
            <div class="col-8">
                <input class="form-control" id="fullAddress" [value]="ndg.fullAddress" disabled="true">
            </div>
        </div>

        <!-- DATE OF BIRTH -->
        <div class="form-group row my-3">
            <label for="dateOfBirth" class="col-4 col-form-label">{{ "survey.new.ndg-data.birth-date" | translate }}</label>
            <div class="col-8">
                <input class="form-control" id="dateOfBirth" [value]="ndg.dateOfBirth" disabled="true">
            </div>
        </div>

        <!-- OCCUPATION -->
        <div class="form-group row my-3">
            <label for="occupation" class="col-4 col-form-label">{{ "survey.new.ndg-data.occupation" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="occupation" formControlName="occupation" [attr.disabled]="completed">
                    <option value=""></option>
                    <option *ngFor="let key of ['DPU', 'IMP', 'IPU', 'OPU', 'DPR', 'IPR', 'OPR', 'LPR', 'ART', 'COM', 'PEN', 'STD', 'NLV']" [value]="key">
                        {{ "survey.domain.ndg.occupation." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(occupation)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- GRADUATION -->
        <div class="form-group row my-3">
            <label for="graduation" class="col-4 col-form-label">{{ "survey.new.ndg-data.graduation" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="graduation" formControlName="graduation" [attr.disabled]="completed">
                    <option value=""></option>
                    <option *ngFor="let key of ['LAU', 'DIP', 'MED', 'ELE']" [value]="key">
                        {{ "survey.domain.ndg.graduation." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(graduation)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- FAMILY SIZE -->
        <div class="form-group row my-3">
            <label for="familySize" class="col-4 col-form-label">{{ "survey.new.ndg-data.family-size" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="familySize" formControlName="familySize" [attr.disabled]="completed">
                    <option value=""></option>
                    <option *ngFor="let key of ['FC1', 'FC2', 'FC3', 'FC4', 'FC5']" [value]="key">
                        {{ "survey.domain.ndg.family-size." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(familySize)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- MARITAL STATUS -->
        <div class="form-group row my-3">
            <label for="maritalStatus" class="col-4 col-form-label">{{ "survey.new.ndg-data.marital-status" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="maritalStatus" formControlName="maritalStatus" [attr.disabled]="completed">
                    <option value=""></option>
                    <option *ngFor="let key of ['SC1', 'SC2', 'SC5', 'SC3', 'SC6', 'SC4']" [value]="key">
                        {{ "survey.domain.ndg.marital-status." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(maritalStatus)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- OTHER INSURED -->
        <div class="form-group row my-3">
            <label for="otherInsured" class="col-4 col-form-label">{{ "survey.new.ndg-data.other-insured" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="otherInsured" formControlName="otherInsured" [attr.disabled]="completed">
                    <option value=""></option>
                    <option *ngFor="let key of ['AS1', 'AS2', 'AS3']" [value]="key">
                        {{ "survey.domain.ndg.other-insured." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(otherInsured)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- HERITAGE FINANCIAL -->
        <div class="form-group row my-3">
            <label for="financialHeritage" class="col-4 col-form-label">{{ "survey.new.ndg-data.heritage-financial" | translate }}</label>
            <div class="col-8">
                <input prefix="€ " mask="separator.0" thousandSeparator="." type="text" class="form-control" id="financialHeritage" formControlName="financialHeritage" [attr.disabled]="completed">
            </div>
        </div>

        <!-- AVERAGE INCOME -->
        <div class="form-group row my-3">
            <label for="averageIncome" class="col-4 col-form-label">{{ "survey.new.ndg-data.average-income" | translate }}</label>
            <div class="col-8">
                <input prefix="€ " mask="separator.0" thousandSeparator="." type="text" class="form-control" id="averageIncome" formControlName="averageIncome" [attr.disabled]="completed">
            </div>
        </div>
        
        <!-- SUBMIT -->
        <button *ngIf="isInsert()" class="btn btn-primary mt-3 next-step" [disabled]="completed" (click)="onSubmit()">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            {{ 'survey.new.ndg-data.next' | translate }}
        </button>
    </div>
</div>
